<div class="main_content">

   <div class="loader"
        *ngIf="isLoading$ | async">
      <span class="loader-icon"></span>
      <span class="loader-text">Initialization</span>
   </div>

   <div class="add_to_sheet">
      <button *ngIf="error"
              (click)="initialize()">
         <span>TRY AGAIN</span>
      </button>
   </div>

   <div class="error"
        *ngIf="error">
      <span>Error: {{error}}</span>
   </div>

</div>
